import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const plansDirectoryRoute: InvariantJiraRoute = {
	name: 'plans-directory',
	path: '/jira/plans',
};
